export enum FRAUD_REASON {
  BRICKING = 'Bricking',
  CONTENT_SUBSTITUTION = 'ContentSubstitution',
  DOCUMENT_FALSIFICATION = 'DocumentFalsification',
  COUNTERFEIT = 'Counterfeit',
  WARDROBING = 'Wardrobing',
}
